export const Colors = {
  primary: "#2E9BE2",
  secondary: "#E51D49",
  third: "#eeeeee",
};
